import { useMutation } from '@tanstack/react-query'
import { NoContent } from '@/common/types_and_interfaces.ts'
import { ApiCallResult } from '@/lib/tanstack-utils.types.ts'
import axios from 'axios'
import { parseRequestError } from '@/common/utilities.ts'

export type DistributionModifierPayloadItem = {
  id: number
  base_amount: number
  modifier_type_id: number
  grade_level_id: number
  is_active: boolean
}

export type DistributionModifierPayload = DistributionModifierPayloadItem[]

export type UpdateModifierParams = {
  programId: number
  purseId: number
}

const updateDistributionModifiers = async (
  params: UpdateModifierParams,
  payload: DistributionModifierPayload
): Promise<NoContent> => {
  const { programId, purseId } = params
  try {
    await axios.post(
      `/programs/${programId}/purses/${purseId}/settings/special_education_modifiers`,
      { special_education_modifiers: payload }
    )
    return null
  } catch (e) {
    throw parseRequestError(e)
  }
}

type RequestPayload = {
  params: UpdateModifierParams
  payload: DistributionModifierPayload
}

export const useUpdateDistributionModifiers = (): ApiCallResult<
  NoContent,
  RequestPayload
> => {
  return useMutation({
    mutationFn: async ({ params, payload }: RequestPayload) => {
      return await updateDistributionModifiers(params, payload)
    },
  })
}
